'use client';

import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { createThemeOptions } from '@/functions/createTheme';
import { useVersion } from '@/hooks/useVersion';

type Props = {
  children: React.ReactNode;
  customerSetting: CustomerSetting;
};

export const Provider: React.FC<Props> = ({ children, customerSetting }) => {
  // テーマのオプションを定義
  const theme = createTheme(createThemeOptions(customerSetting.themeColor));
  // バージョンのセット
  useVersion();

  return (
    <AppRouterCacheProvider options={{ key: 'css' }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header customerSetting={customerSetting} />
        {children}
        <Footer customerSetting={customerSetting} />
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
};
